import { render, staticRenderFns } from "./NotificationTile.vue?vue&type=template&id=741041fd"
import script from "./NotificationTile.vue?vue&type=script&lang=js"
export * from "./NotificationTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports